/* (ignored) */


//////////////////
// WEBPACK FOOTER
// vertx (ignored)
// module id = 55
// module chunks = 1